import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import { IFormBasicInfo } from 'legacy/lut/classes/models/partner360/IFormBasicInfo'

import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'

import { JBP_PARTNER_BASIC_INFO_CRUD_KEY } from '../constants'

export const getJBPBasicInfoCrud = (keySuffix?: string): Crud<IFormBasicInfo> => {
  const crudKey = keySuffix
    ? `${JBP_PARTNER_BASIC_INFO_CRUD_KEY}_${keySuffix}`
    : JBP_PARTNER_BASIC_INFO_CRUD_KEY

  return CrudStore.get(CrudStoreItemPartner360.JBPBasicInfo, crudKey) as Crud<IFormBasicInfo>
}
